import { useQueryClient } from '@tanstack/react-query';
import {
	fetchSettingsQuery,
	saveSettingsQuery,
	useAxiosInstance,
	usePoMutation,
	usePoQuery,
} from '@gov-nx/api';
import type { PoIdentityType } from '@gov-nx/auth/common';
import { useIdentity } from '@gov-nx/auth/common';
import { LocalizationLanguage } from '@gov-nx/core/app';
import type { Nullable } from '@gov-nx/core/types';
import { useUserStore } from '@gov-nx/store';

export const useUserLanguageLoader = () => {
	const key = 'LANG';
	const queryKey = ['user-settings-app-portal-obcana', key];
	const poIdentityContext = useIdentity() as Nullable<PoIdentityType>;
	const setUserSettingLanguage = useUserStore('setUserSettingLanguage');
	const queryClient = useQueryClient();
	const { axiosInstance } = useAxiosInstance();

	usePoQuery({
		queryKey,
		enabled: poIdentityContext?.isAuthenticated,
		queryFn: async (): Promise<LocalizationLanguage> => {
			const data = await fetchSettingsQuery(axiosInstance, key);
			if (!data.hodnota) {
				return LocalizationLanguage.Czech;
			}

			const transformed =
				data.hodnota === 'en'
					? LocalizationLanguage.English
					: LocalizationLanguage.Czech;

			setUserSettingLanguage(transformed);

			return transformed;
		},
	});

	const saveUserSettingMutation = usePoMutation({
		mutationFn: (language: LocalizationLanguage) =>
			saveSettingsQuery(axiosInstance, { klic: key, hodnota: language }),
		onSuccess: (_, variables) => {
			queryClient.setQueryData(queryKey, variables);
		},
	});

	return {
		updateLanguage: saveUserSettingMutation.mutate,
	};
};
